export default __webpack_public_path__ + "static/media/gallery_09.1bb5c1cc.jpg";